import clsx from 'clsx';

type StatusBadgeProps = {
  isDraft: boolean;
};

export const StatusBadge = ({ isDraft }: StatusBadgeProps) => {
  const draftClass = 'bg-white text-cyan-800';
  const publishedClass = 'bg-cyan-800 text-white';
  return (
    <span
      className={clsx(
        'border border-cyan-800 rounded-full px-3 py-1 text-black text-xs font-bold',
        isDraft ? draftClass : publishedClass
      )}>
      {isDraft ? 'Draft' : 'Published'}
    </span>
  );
};
